import { match } from 'ts-pattern';

type Environment = 'test' | 'acceptance' | 'production' | 'local' | 'unset';

export function isProductionEnvironment() {
  return import.meta.env.VITE_RELEASE_ENVIRONMENT === 'production';
}

export function isAcceptanceEnvironment() {
  return import.meta.env.VITE_RELEASE_ENVIRONMENT === 'acceptance';
}

export function isTestEnvironment() {
  return import.meta.env.VITE_RELEASE_ENVIRONMENT === 'test';
}

export function getEnvironment() {
  return match(import.meta.env.VITE_RELEASE_ENVIRONMENT)
    .returnType<Environment>()
    .with('test', () => 'test')
    .with('local', () => 'local')
    .with('acceptance', () => 'acceptance')
    .with('production', () => 'production')
    .otherwise(() => 'unset');
}
